<template>
  <div class="user-center">
    <a-dropdown>
      <a-avatar class="bg-p">
        <template #icon>
          <UserOutlined />
        </template>
      </a-avatar>
      <template #overlay>
        <a-menu>
          <a-menu-item @click="goToHome">
            <template #icon>
              <HomeOutlined />
            </template>
            Home
          </a-menu-item>
          <a-menu-item @click="goToPricing">
            <template #icon>
              <DollarOutlined />
            </template>
            Pricing
          </a-menu-item>
          <a-menu-item @click="goToOrders">
            <template #icon>
              <ShoppingCartOutlined />
            </template>
            Orders
          </a-menu-item>
          <a-menu-item @click="goToReports">
            <template #icon>
              <FileTextOutlined />
            </template>
            Reports
          </a-menu-item>
          <a-menu-item @click="goToInvoices">
            <template #icon>
              <FileDoneOutlined />
            </template>
            Invoices
          </a-menu-item>
          <a-menu-item @click="goToTickets">
            <template #icon>
              <CustomerServiceOutlined />
            </template>
            Support Tickets
          </a-menu-item>
        </a-menu>
      </template>
    </a-dropdown>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from "vue-router";
import {
  UserOutlined,
  ShoppingCartOutlined,
  FileTextOutlined,
  FileDoneOutlined,
  CustomerServiceOutlined,
  HomeOutlined,
  DollarOutlined,
} from "@ant-design/icons-vue";

const router = useRouter();

// Navigation handlers
const goToHome = () => {
  router.push("/");
};

const goToPricing = () => {
  router.push("/pricing");
};

const goToOrders = () => {
  router.push("/billing/orders");
};

const goToReports = () => {
  router.push("/reports");
};

const goToInvoices = () => {
  router.push("/billing/invoices");
};

const goToTickets = () => {
  router.push("/tickets");
};

const logout = () => {
  // 实现登出逻辑
  console.log("Logging out...");
  // 可能需要清除session storage或cookies等
  router.push("/");
};
</script>

<style scoped>
.user-center {
  position: fixed;
  top: 9px;
  right: 40px;
  z-index: 1000;
  cursor: pointer;
}

.user-avatar {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
</style>
